/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Actual_CloseInputs */

const cs_field_actual_close = /** @type {(inputs: Field_Actual_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skutečné uzavření`)
};

const en_field_actual_close = /** @type {(inputs: Field_Actual_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual close`)
};

/**
* | output |
* | --- |
* | "Actual close" |
*
* @param {Field_Actual_CloseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_actual_close = /** @type {((inputs?: Field_Actual_CloseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Actual_CloseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_actual_close(inputs)
	return cs_field_actual_close(inputs)
});